var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenshot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H20C21.1046 0 22 0.89543 22 2V16C22 17.1046 21.1046 18 20 18H2ZM20 2H2V16H20V2ZM10 4C9.28047 4 8.67334 4.30584 8.18432 4.78768C8.11201 4.85893 8.04589 4.93006 7.9857 5H7.4C6.05851 5 5 6.13412 5 7.5V11.5C5 12.8659 6.05851 14 7.4 14H14.6C15.9415 14 17 12.8659 17 11.5V7.5C17 6.13412 15.9415 5 14.6 5H14.0143C13.9541 4.93006 13.888 4.85893 13.8157 4.78768C13.3267 4.30584 12.7195 4 12 4H10ZM10 6C9.87061 6 9.73333 6.06916 9.58803 6.21232C9.48041 6.31836 9.40599 6.42598 9.38365 6.46816L9.10188 7H7.4C7.19509 7 7 7.20903 7 7.5V11.5C7 11.791 7.19509 12 7.4 12H14.6C14.8049 12 15 11.791 15 11.5V7.5C15 7.20903 14.8049 7 14.6 7H12.8981L12.6164 6.46816C12.594 6.42598 12.5196 6.31836 12.412 6.21232C12.2667 6.06916 12.1294 6 12 6H10ZM9 9C9 10.1046 9.89543 11 11 11C12.1046 11 13 10.1046 13 9C13 7.89543 12.1046 7 11 7C9.89543 7 9 7.89543 9 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.335ed5b0a6514cd17a28f08e7810495b.svg";
export { ForwardRef as ReactComponent };